export enum TaskStatusEnum {
  Published = 'published',
  Editing = 'editing',
}
